import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import {
  AuditOutlined,
  CalendarOutlined,
  CloseSquareOutlined,
  QuestionCircleOutlined,
  ExportOutlined,
} from "@ant-design/icons";
// import MerchantReportOrderDetails from "./MerchantReportOrderDetails";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
// import MerchantReading from "./MerchantReading";
import * as XLSX from "xlsx";
import MerchantARReportOrderDetails from "./MerchantARReportOrderDetails";
// import MerchantReportPerProduct from "./MerchantReportPerProduct";

const MerchantAccountsReceivable = ({ rerunVoid, rerunWaste }) => {
  const [dataList, setDataList] = useState({
    data: [],
    ready: false,
  });
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [totalGross, setTotalGross] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalCostPerProd, setTotalCostPerProd] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const navigate = useNavigate();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [voidDialog, setVoidDialog] = useState(false);
  const [detectFilter, setDetectFilter] = useState(false);
  const [openReaderDrawer, setOpenReaderDrawer] = useState(false);
  const [openPerProdDrawer, setOpenPerProdDrawer] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "",
      render: (text) => (
        <div
          style={{
            width: 10,
            height: 10,
            backgroundColor: parseFloat(text.discount) !== 0 ? "red" : "green",
            marginRight: 5,
          }}
        />
      ),
    },
    {
      title: "Transaction Date",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      sorter: (a, b) => a.transaction_id - b.transaction_id,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Location",
      // title: userData.data.usersmerpermission.find(
      //   ({ permission }) => permission === "allow-dine-setup"
      // )
      //   ? "Location"
      //   : "Table Number",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Employee Name",
      dataIndex: "employee_fullname",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 80 }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              //   style={{ marginRight: 5 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getEmployeeList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 1 };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getMerchantOrderSaveList = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      status: 1,
      orderby: "desc",
      order_category: "all",
      date_from: moment().subtract(6, "days").format("YYYY-MM-DD"),
      date_to: moment().format("YYYY-MM-DD"),
    };
    axios
      .get("user/merchant/ar/report-customer-order-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        const res = _.chain(data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: _.orderBy(value, ["id"], ["asc"]),
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            employee_fullname:
              value[0].chargetoemployeeinfo !== null
                ? `${value[0].chargetoemployeeinfo.lastname}, ${value[0].chargetoemployeeinfo.firstname}`
                : "",
            cost: getTotalCost(value),
            cost_per_prod: getTotalCostPerProd(
              _.orderBy(value, ["id"], ["asc"])
            ),
            discount: getTotalDiscount(value),
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setMerchantOrderSaveList({ data: res2, ready: true });
        setTotalGross(calculateTotal(res, "gross"));
        // setTotalDiscount(calculateTotal(res, "discount"));
        // setTotalCostPerProd(calculateTotal(res, "cost_per_prod"));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const handleFilter = (values) => {
    var DATEFROM = moment(new Date(values.date_from)).format("YYYY-MM-DD");
    var DATETO = moment(new Date(values.date_to)).format("YYYY-MM-DD");

    var date_from = "";
    var date_to = "";

    if (
      userData.data.usersmerinfo.operation_opens !== null &&
      userData.data.usersmerinfo.operation_closes !== null
    ) {
      if (
        userData.data.usersmerinfo.operation_closes <
        userData.data.usersmerinfo.operation_opens
      ) {
        const dateFormat = "YYYY-MM-DDTHH:mm:ss";
        date_from = moment(
          `${DATEFROM}T${userData.data.usersmerinfo.operation_opens}`,
          dateFormat
        ).format(dateFormat);
        date_to = moment(
          `${DATETO}T${userData.data.usersmerinfo.operation_closes}`,
          dateFormat
        )
          .add(1, "days")
          .format(dateFormat);
      } else {
        date_from = moment(
          `${DATEFROM}T${userData.data.usersmerinfo.operation_opens}`
        ).format("YYYY-MM-DDTHH:mm:ss");
        date_to = moment(
          `${DATETO}T${userData.data.usersmerinfo.operation_closes}`
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
    } else {
      date_from = moment(`${DATEFROM}T00:00:00`).format("YYYY-MM-DDTHH:mm:ss");
      date_to = moment(`${DATETO}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");
    }

    var params = {
      date_from,
      date_to,
      user_id: userData.data.id,
      status: 1,
      orderby: "desc",
      employee: values.employee,
    };

    setDateFrom(moment(date_from).format("YYYY-MM-DD HH:mm:ss"));
    setDateTo(moment(date_to).format("YYYY-MM-DD HH:mm:ss"));
    setLoading(true);
    axios
      .get("user/merchant/filter/ar/customer-order-list", { params })
      .then((response) => {
        rerunNotif("success", "Filter successful.");
        const data = response.data;
        const res = _.chain(data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            employee_fullname:
              value[0].chargetoemployeeinfo !== null
                ? `${value[0].chargetoemployeeinfo.lastname}, ${value[0].chargetoemployeeinfo.firstname}`
                : "",
            cost: getTotalCost(value),
            cost_per_prod: getTotalCostPerProd(
              _.orderBy(value, ["id"], ["asc"])
            ),
            discount: getTotalDiscount(value),
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setMerchantOrderSaveList({ data: res2, ready: true });
        setTotalGross(calculateTotal(res, "gross"));
        // setTotalDiscount(calculateTotal(res, "discount"));
        // setTotalCostPerProd(calculateTotal(res, "cost_per_prod"));

        setOpenFilterByDate(false);
        setLoading(false);
        setDetectFilter(true);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const calculateTotal = (data, mode) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (mode === "gross") {
        total += parseFloat(data[i].cost) * 1;
      }
      //   if (mode === "discount") {
      //     total += parseFloat(data[i].discount) * 1;
      //   }
      //   if (mode === "cost_per_prod") {
      //     total += parseFloat(data[i].cost_per_prod) * 1;
      //   }
    }
    return total;
  };

  const getTotalCost = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      // console.log("res: ", res);
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        total +=
          (parseInt(data[i].is_per_piece) === 1
            ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
              parseFloat(data[i].price.replace(",", ""))
            : parseFloat(data[i].price.replace(",", ""))) +
          parseFloat(
            data[i].cost_per_prod !== null
              ? parseInt(data[i].is_per_piece) === 0
                ? data[i].cost_per_prod
                : data[i].cost_per_prod * data[i].quantity
              : 0
          ) -
          parseFloat(data[i].discount_amount);
      }
    }

    return total;
  };

  const getTotalDiscount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount);
    }
    return total;
  };

  const getTotalCostPerProd = (data) => {
    var total = 0;
    if (
      data[0].service_type === "consumable" &&
      data[0].order_category === "additional-service"
    ) {
      const res = _.chain(data)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].per_product)
          : (total = res[1].per_product)
        : (total = res[0].per_product);
      // console.log("TOTAL: ", total);
      return total;
    } else {
      for (let i = 0; i < data.length; i++) {
        total += parseFloat(
          data[i].cost_per_prod !== null
            ? parseInt(data[i].is_per_piece) === 0
              ? data[i].cost_per_prod
              : data[i].cost_per_prod * data[i].quantity
            : 0
        );
      }
      // console.log("TOTAL: ", total);

      return total;
    }
  };

  useEffect(() => {
    getEmployeeList();
    getMerchantOrderSaveList();
  }, [getEmployeeList, getMerchantOrderSaveList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const totalCostPerProduct = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(
          data[i].cost_per_prod !== null
            ? parseFloat(data[i].cost_per_prod) * parseFloat(data[i].quantity)
            : 0
        ) * 1;
    }
    return total;
  };

  const totalConsumption = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        data[i].service_type === "consumable"
          ? parseFloat(data[i].price) * 1
          : parseFloat(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  const discountConsumption = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount) * 1;
    }
    return total;
  };

  const exportToExcel = () => {
    const selectedColumns = [
      "transaction_id",
      "customer_name",
      "created_at",
      "table_no",
      "service_category",
      "employee_fullname",
      "cost",
    ]; // Add columns you want to export
    const filteredData = searchable.map((row) => {
      const filteredRow = {};
      selectedColumns.forEach((column) => {
        filteredRow[column] = row[column];
      });
      return filteredRow;
    });

    // const worksheet = XLSX.utils.json_to_sheet(
    //   searchable.length > 0 ? searchable : []
    // );
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "digimenu_ar_report.xlsx");
  };

  return (
    <div>
      {/* <div>
        <Typography
          style={{ fontStyle: "italic", color: "blue", fontWeight: "bold" }}
        >
          Note: The default is 1 week record transaction, but you can use filter
          to fetch the desire date range and generate report.
        </Typography>
      </div> */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: 10,
            height: 10,
            backgroundColor: "red",
            marginRight: 5,
          }}
        />
        <Typography style={{ fontWeight: "bold" }}>Discounted</Typography>
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        <div
          style={{
            width: 10,
            height: 10,
            backgroundColor: "green",
            marginRight: 5,
          }}
        />
        <Typography style={{ fontWeight: "bold" }}>Non-Discounted</Typography>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Tooltip title="Excel Export">
          <Button
            icon={<ExportOutlined />}
            style={{ marginRight: 5 }}
            onClick={exportToExcel}
          >
            Export
          </Button>
        </Tooltip>

        <Tooltip title="Filter by date">
          <Button
            icon={<CalendarOutlined />}
            style={{ marginRight: 5 }}
            onClick={() => setOpenFilterByDate(true)}
          >
            Filter
          </Button>
        </Tooltip>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
          summary={() => (
            <Table.Summary fixed={"bottom"}>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={7} align="right">
                  <p style={{ fontWeight: "bold" }}>
                    Total:{" "}
                    {totalGross.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </div>

      {/* REPORT DETAILS  */}
      {openDrawer && (
        <MerchantARReportOrderDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
          rerunVoid={() => rerunVoid()}
          rerunWaste={() => rerunWaste()}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="report-filter"
          initialValues={{ employee: "all" }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="employee"
              label="Employee"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select placeholder="Select employee" size="large">
                <Select.Option value={"all"}>All</Select.Option>
                {employeeList.data.length > 0 &&
                  employeeList.data.map((data, index) => (
                    <Select.Option value={data.user_id} key={index}>
                      {data.firstname} {data.lastname}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default MerchantAccountsReceivable;
